import SectionHead from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import { WHY_POINTS } from "@/lib/data";

export default function WhySection() {
  return (
    <section data-testid="why-section" className="relative py-24">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHead
          overline="Why Talentify"
          title="Why Businesses Choose Talentify"
          sub="Experience, expertise and a partnership approach — built for serious hiring requirements."
          testid="why-heading"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {WHY_POINTS.map((w, i) => (
            <Reveal key={w.title} delay={i * 0.07}>
              <div
                data-testid={`why-card-${i + 1}`}
                className="group h-full rounded-2xl border border-white/[0.08] bg-[#0A0F1D]/60 p-7 transition-[border-color,background-color,transform] duration-500 hover:-translate-y-1 hover:border-indigo-400/30 hover:bg-[#0F172A]/70"
              >
                <span className="mb-5 grid h-11 w-11 place-items-center rounded-xl border border-white/[0.08] bg-white/[0.03] text-indigo-400 transition-colors duration-500 group-hover:border-indigo-400/40 group-hover:text-indigo-300">
                  <w.icon size={20} />
                </span>
                <h3 className="font-display text-lg font-semibold text-white">{w.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{w.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
